<template>
    <div class="hero-section">
        <div class="container">
            <div class="hero-content">
                <div class="hero-text-section">
                    <p class="hero-text">اكتشف عالَم العلوم و الجيولوجيا مع مستر أحمد <span class="hero-subtext">مكاوي</span></p>
                    <p class="hero-description">دروس مبسطة، شروحات دقيقة، ومواد تعليمية تساعدك على التطور في العلوم و الجيولوجيا من الإعدادي للثانوي.</p>
                    <div class="button-container">
                        <router-link to="/register" class="explore-button">إبدأ معنا الآن</router-link>
                        <router-link to="/login" class="contact-button">سجل الدخول</router-link>
                    </div>
                    <div class="wavy-line"></div>
                </div>
                <div class="hero-image-section">
                    <img src="../../assets/images/avatar.png" alt="Hero Image" class="avatar-img"/>
                    <div class="icon_1 floating-delay"><img src="../../assets/images/earth.svg"/></div>
                    <div class="icon_2 floating"><img src="../../assets/images/volcano.svg"/></div>
                    <div class="icon_3 floating"><img src="../../assets/images/icon.svg"/></div>
                    <div class="images-container">
                        <img class="user-image" src="../../assets/images/image_1.png" alt="pic-1">
                        <img class="user-image" src="../../assets/images/image_2.jpg" alt="pic-1">
                        <img class="user-image" src="../../assets/images/image_3.png" alt="pic-1">
                        <img class="user-image" src="../../assets/images/image_4.png" alt="pic-1">
                        <p class="student-count"><span>5k+</span>طالب</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.hero-section {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background: linear-gradient(217deg, rgba(0, 190, 171, 0.6) 0%, rgba(0, 190, 171, 0.25) -6%, rgba(255, 239, 214, 1) 52%, rgba(255, 157, 0, 0.4) 100%);
    overflow: hidden;
    padding-top: 10%;
}

.container {
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 20px;
}

.hero-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 40px;
}

.hero-text-section {
    width: 75%;
    position: relative;
}

.hero-text {
    font-size: clamp(36px, 5vw, 66px);
    font-weight: 700;
    color: #000;
    margin-bottom: 20px;
}
/* 
.hero-subtext {
    color: #FF9A18;
    position: relative;
    display: inline-block;
}

.hero-subtext::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -20px;
    width: 100%;
    height: 30px;
    background: url("../../assets/images/line.svg");
    background-repeat: repeat-x;
    background-size: contain;
    z-index: -1;
    animation: waveMove 8s linear infinite;
} */

.hero-description {
    font-size: clamp(18px, 2.2vw, 22px);
    color: #7F8685;
    padding-top: 20px;
    line-height: 1.6;
    max-width: 90%;
}

.wavy-line {
    width: 100%;
    max-width: 670px;
    height: clamp(80px, 10vw, 120px);
    background: no-repeat center / contain url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 500 120'><circle cx='20' cy='40' r='8' fill='%2300c4c7'/><path d='M20 40 Q 100 150, 200 80 T 380 120 T 500 80' stroke='%2300c4c7' stroke-width='4' stroke-dasharray='12 10' stroke-linecap='round' fill='none'/></svg>");
    margin-top: 0;
    rotate: 30deg;
}

.button-container {
    display: flex;
    gap: clamp(20px, 3vw, 50px);
    margin-top: 30px;
    flex-wrap: wrap;
}

.explore-button, .contact-button {
    font-size: clamp(16px, 1.8vw, 20px);
    font-weight: 500;
    padding: clamp(10px, 1.5vw, 12px) clamp(16px, 2vw, 24px);
    border-radius: 32px;
    cursor: pointer;
    transition: all 0.3s;
    min-width: 150px;
}

.explore-button {
    background-color: #FF9A18;
    color: #fff;
    border: none;
}

.contact-button {
    background-color: transparent;
    color: #FF9A18;
    border: 1px solid #FF9A18;
}

.explore-button:hover {
    background-color: #e68a00;
    transform: translateY(-2px);
}

.contact-button:hover {
    background-color: rgba(255, 154, 24, 0.1);
}

.hero-image-section {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 1;
    overflow: hidden;
    display: flex;
    justify-content: end;
}

.hero-image-section .icon_1,
.hero-image-section .icon_2,
.hero-image-section .icon_3 {
    position: absolute;
    transition: all 0.3s ease;
}
.hero-image-section .icon_1 {
    top: 22%;
    left: 9%;
}
.hero-image-section .icon_2 {
    top: 60px;
    left: 37%;
}
.hero-image-section .icon_3 {
    top: 51%;
    left: 10px;
}

.images-container {
    background-color: #fff;
    display: flex;
    align-items: center;
    border-radius: 50px;
    position: absolute;
    bottom: 0;
    right: 40%;
    padding: 10px;
}
.images-container .user-image {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-left: -20px;
  border: 3px solid #fff;
  transition: all 0.3s ease-in-out;
}
.images-container .student-count {
    font-size: 22px;
    color: #000;
    margin: 0;
    margin-right: 26px;
    display: flex;
    gap: 9px;
    font-weight: 400;
}
.images-container .student-count span{
    font-size: 26px;
    font-weight: 600;
    color: #FF9A18;
}
@keyframes waveMove {
    from { background-position-x: 0; }
    to { background-position-x: 100px; }
}

@keyframes floating {
    0%, 100% { transform: translateY(0) rotate(-2deg); }
    50% { transform: translateY(-15px) rotate(2deg); }
}

@keyframes floating-delay {
    0%, 100% { transform: translateY(-5px) rotate(2deg); }
    50% { transform: translateY(10px) rotate(-2deg); }
}

.floating { animation: floating 3s ease-in-out infinite; }
.floating-delay { animation: floating-delay 4s ease-in-out infinite; }

@media (max-width: 1200px) {
    .hero-content {
        flex-direction: column-reverse;
        text-align: center;
    }
    .hero-image-section{
        justify-content: center;
    }
    .hero-text-section, 
    .hero-image-section {
        width: 100%;
    }
        .hero-image-section .icon_1,
    .hero-image-section .icon_2,
    .hero-image-section .icon_3 {
        display: none;
    }
        .button-container {
        justify-content: center;
        z-index: 1;
        position: relative;
    }
}

@media (max-width: 992px) {
    .hero-content {
        flex-direction: column-reverse;
        text-align: center;
    }
    
    .hero-text-section, 
    .hero-image-section {
        width: 100%;
    }
    
    .hero-description {
        margin: 0 auto;
    }
    
    .button-container {
        justify-content: center;
    }
    
    .wavy-line {
        margin: 20px auto;
    }
    
    .hero-image-section {
        margin-top: 40px;
        min-height: 300px;
        overflow: visible;
        justify-content: center;
    }
    .hero-image-section img {
        width: 70%;
    }
    .hero-subtext::after {
        bottom: -15px;
        height: 20px;
    }

}

@media (max-width: 576px) {
    .hero-section {
        padding: 60px 15px 30px;
    }
    
    .hero-text {
        font-size: 28px;
        margin-bottom: 15px;
    }
    
    .hero-description {
        font-size: 16px;
        padding-top: 15px;
    }
    
    .button-container {
        flex-direction: column;
        gap: 12px;
    }
    
    .explore-button, 
    .contact-button {
        width: 100%;
    }
    
    .hero-image-section .icon_1 {
        top: 10%;
        right: 10%;
    }
    
    .hero-image-section .icon_2 {
        top: 5%;
        left: 30%;
    }
    
    .hero-image-section .icon_3 {
        bottom: 15%;
        left: 15%;
    }
    .images-container {
        display: none;
    }
}

@media (min-width: 1600px) {
    .container {
        max-width: 1600px;
    }
    
    .hero-text {
        font-size: 72px;
    }
    
    .hero-description {
        font-size: 24px;
    }
}
</style>